import { Position, State } from 'src/types'
// 背面の描画
import { indexFingerCover } from 'src/features/atoms/glove/drawer/rightThrow/glove/back/fingerCoverOrPad/indexFingerCover'
import { lace } from 'src/features/atoms/glove/drawer/rightThrow/glove/back/lace'
import { lining } from 'src/features/atoms/glove/drawer/rightThrow/glove/back/lining'
import { littleHook } from 'src/features/atoms/glove/drawer/rightThrow/glove/back/hooks/littleHook'
import { thumbHook } from 'src/features/atoms/glove/drawer/rightThrow/glove/back/hooks/thumbHook'
import { atomsLabelDrawerForGloveLeftThrow, backLaceDrawer } from 'src/features/atoms/glove/drawer/common/useCanvasHelper'
import { webOfGloveBackDrawer } from 'src/features/atoms/glove/drawer/rightThrow/glove/back/web/useCanvasWebsBack'
import { backStyleOfGloveBackDrawer } from 'src/features/atoms/glove/drawer/leftThrow/glove/back/backStyles'
import { laceOfWristBeltCrossDrawer } from 'src/features/atoms/glove/drawer/rightThrow/glove/back/lace/laceOfWristBeltFix'
import { canvasResetter, thumbEmbroideryDrawerLeftThrow } from 'src/util/canvas'
import { liningEmbroideryDrawerLeftThrow, nonThumbEmbroideryDrawerLeftThrow, startInversion, undoInversion } from 'src/util/canvas'
import { loopOfRingFinger } from '../../../common/back/loopOfRingFinger'
import { positionChecker, backStyleChecker } from 'src/logic'
import { isDefault_AGL_NE_105 } from 'src/features/atoms/glove/logic'

export const atomsCanvasGloveBackLeftThrow = async (
  ctx: CanvasRenderingContext2D,
  state: State,
  position: Position,
  canvasWidth: number
): Promise<void> => {
  const { isPitcher } = positionChecker(position)
  const productNumber = state.baseModel.productNumber
  const isIndexFingerCover =
    state.fingerGuardType?.value == 'indexCover' || (state.fingerGuardType?.value === 'unselected' && isPitcher && productNumber !== 'AJA-01')
  const { isFirstBackStyle } = backStyleChecker(state.backStyle?.value)
  const needCatchFaceWrap = (!state.baseModel?.isUBack && !isFirstBackStyle) || false

  const stitchColor = state.stitch.color
  const laceColor = state.lace.color

  // リセット
  canvasResetter(ctx)
  ctx.lineWidth = 0.7
  startInversion(ctx, canvasWidth)
  lining(ctx, state.linings?.color) // 裏革
  undoInversion(ctx, canvasWidth) // 反転解除

  liningEmbroideryDrawerLeftThrow(ctx, state.embroideries, 'first') // 平裏の刺繍描画1段目
  liningEmbroideryDrawerLeftThrow(ctx, state.embroideries, 'second') // 平裏の刺繍描画2段目

  startInversion(ctx, canvasWidth) // 反転開始
  //
  if (state.loopOfRingFinger.value === 'loopOfRingFinger') {
    loopOfRingFinger(ctx, state.loopOfRingFingerColor?.color, stitchColor)
  }

  await backStyleOfGloveBackDrawer(ctx, state, needCatchFaceWrap, canvasWidth) // バックスタイルの描画(ハミダシ,親指刺繍含)
  undoInversion(ctx, canvasWidth)
  thumbEmbroideryDrawerLeftThrow(ctx, state.embroideries, state.backStyle)
  startInversion(ctx, canvasWidth)

  // 指カバー
  const _isDefault_AGL_NE_105 = isDefault_AGL_NE_105(productNumber, state.webParts.value)
  if (isIndexFingerCover && !_isDefault_AGL_NE_105) {
    const printLeatherTypeValue = state.printLeatherType?.value
    await indexFingerCover(ctx, state.indexCover.color, stitchColor, printLeatherTypeValue) // 指カバー
  }
  undoInversion(ctx, canvasWidth)
  // 小指への刺繍
  nonThumbEmbroideryDrawerLeftThrow(ctx, 'childFinger', state.embroideries)
  startInversion(ctx, canvasWidth)

  await webOfGloveBackDrawer(ctx, state) // ウェブの描画
  // 革紐
  lace(ctx, laceColor)
  laceOfWristBeltCrossDrawer(ctx, laceColor, isFirstBackStyle)
  // 背面紐通し(オプション)
  backLaceDrawer(ctx, state?.backLace?.value, laceColor, position, productNumber)
  // 小指掛け紐
  littleHook(ctx, state.littleHook?.color, 25, 240, -10, 0.7)
  // 親指掛け紐
  thumbHook(ctx, state.thumbHook?.color, 110, -310, 15) // 先端
  thumbHook(ctx, state.thumbHook?.color, -14, 30, 0) //手元
  undoInversion(ctx, canvasWidth)
  // ラベル描画
  atomsLabelDrawerForGloveLeftThrow(ctx, state)
}
